export default __webpack_public_path__ + "51ac49044a69943cae37653430ed180b.svg";